import React from 'react';
import { motion } from 'framer-motion';
import { Award, ShieldCheck, Users } from '../utils/icons';
import ProfileSection from '../components/ProfileSection';
import { useI18n } from '../i18n';

const About = () => {
  const { t } = useI18n();

  const values = [
    {
      icon: Award,
      title: t('about.values.items.integrity.title'),
      description: t('about.values.items.integrity.description'),
    },
    {
      icon: ShieldCheck,
      title: t('about.values.items.excellence.title'),
      description: t('about.values.items.excellence.description'),
    },
    {
      icon: Users,
      title: t('about.values.items.community.title'),
      description: t('about.values.items.community.description'),
    },
  ];

  const fadeUp = {
    hidden: { opacity: 1, y: 18 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <div className="pt-20 ccc-site min-h-screen">
      <section className="ccc-brief-hero">
        <div className="ccc-container py-16 md:py-20">
          <p className="ccc-eyebrow mb-5">{t('ui.aboutOperator')}</p>
          <h1 className="ccc-brief-title">{t('about.hero.title')}</h1>
          <p className="ccc-brief-copy mt-6 max-w-3xl">{t('about.hero.subtitle')}</p>
        </div>
      </section>

      <ProfileSection />

      <section className="ccc-section">
        <div className="ccc-container">
          <div className="grid gap-8 lg:grid-cols-[minmax(0,0.72fr)_minmax(18rem,0.38fr)]">
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.25 }}
              className="ccc-ledger p-6 md:p-8"
            >
              <p className="ccc-eyebrow mb-5">{t('about.mission.title')}</p>
              <h2 className="text-3xl font-black text-slate-950 md:text-5xl">
                {t('ui.missionStatement')}
              </h2>
              <p className="ccc-work-copy mt-6">{t('about.mission.text1')}</p>
              <p className="ccc-work-copy mt-4">{t('about.mission.text2')}</p>
            </motion.div>

            <motion.aside
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.25 }}
              className="ccc-ledger-dark p-6"
            >
              <Award className="h-12 w-12 text-amber-300" />
              <p className="ccc-label mt-6">{t('about.veteran.badgeKicker')}</p>
              <h3 className="mt-3 text-2xl font-black text-white">{t('about.veteran.title')}</h3>
              <p className="mt-4 text-sm leading-7 text-slate-300">{t('about.veteran.badgeText')}</p>
            </motion.aside>
          </div>
        </div>
      </section>

      <section className="ccc-section bg-[#e1e9e5]">
        <div className="ccc-container">
          <div className="ccc-section-head">
            <div>
              <p className="ccc-eyebrow mb-4">{t('ui.operatingValues')}</p>
              <h2 className="ccc-section-title">{t('about.values.title')}</h2>
            </div>
            <p className="ccc-section-copy">{t('about.veteran.text2')}</p>
          </div>

          <div className="ccc-scope-grid">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <article key={value.title} className="ccc-scope-cell">
                  <p className="ccc-scope-number">{String(index + 1).padStart(2, '0')}</p>
                  <Icon className="mt-5 h-8 w-8 text-emerald-800" />
                  <h3 className="ccc-scope-title">{value.title}</h3>
                  <p className="ccc-scope-copy">{value.description}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
